// Presets de período curto (Hoje / Esta semana / Última semana / Este mês / Mês
// anterior / Período personalizado) — irmão mais simples de src/lib/periodoFiltro.ts
// (que cobre presets maiores: trimestre/semestre/ano). Semana começa no domingo,
// mesmo padrão já usado em src/components/DateRangePicker.tsx (DAYS_SHORT).

export type PeriodoRapido = 'hoje' | 'semana_atual' | 'semana_anterior' | 'mes_atual' | 'mes_anterior' | 'personalizado';

export interface RangeISO {
    inicio: string; // YYYY-MM-DD
    fim: string;    // YYYY-MM-DD
}

export const PERIODOS_RAPIDOS: Array<{ value: PeriodoRapido; label: string }> = [
    { value: 'hoje', label: 'Hoje' },
    { value: 'semana_atual', label: 'Esta semana' },
    { value: 'semana_anterior', label: 'Última semana' },
    { value: 'mes_atual', label: 'Este mês' },
    { value: 'mes_anterior', label: 'Mês anterior' },
    { value: 'personalizado', label: 'Período personalizado' },
];

const pad2 = (n: number) => String(n).padStart(2, '0');
const iso = (d: Date) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
const addDias = (d: Date, dias: number) => { const c = new Date(d); c.setDate(c.getDate() + dias); return c; };

/** Janela [inicio, fim] (datas locais, YYYY-MM-DD) do preset — `null` só para
 *  'personalizado' sem range ainda escolhido pelo usuário. */
export function resolvePeriodoRapido(p: PeriodoRapido, custom: RangeISO | null, hoje: Date = new Date()): RangeISO | null {
    switch (p) {
        case 'hoje':
            return { inicio: iso(hoje), fim: iso(hoje) };
        case 'semana_atual': {
            const ini = addDias(hoje, -hoje.getDay()); // domingo desta semana
            return { inicio: iso(ini), fim: iso(hoje) };
        }
        case 'semana_anterior': {
            const fimSemanaAtual = addDias(hoje, -hoje.getDay());
            const fim = addDias(fimSemanaAtual, -1);   // sábado da semana passada
            const ini = addDias(fim, -6);               // domingo da semana passada
            return { inicio: iso(ini), fim: iso(fim) };
        }
        case 'mes_atual': {
            const ini = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
            return { inicio: iso(ini), fim: iso(hoje) };
        }
        case 'mes_anterior': {
            const ini = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
            const fim = new Date(hoje.getFullYear(), hoje.getMonth(), 0); // dia 0 = último dia do mês anterior
            return { inicio: iso(ini), fim: iso(fim) };
        }
        case 'personalizado':
            return custom && custom.inicio && custom.fim ? custom : null;
    }
}

/** Início do dia (00:00) e fim do dia (23:59:59.999) locais, prontos pra comparar contra timestamptz. */
export function rangeParaInstantes(r: RangeISO): { inicio: Date; fim: Date } {
    return {
        inicio: new Date(r.inicio + 'T00:00:00'),
        fim: new Date(r.fim + 'T23:59:59.999'),
    };
}
